"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19.98 17.15C20.63 15.91 21 14.5 21 13c-1.5 0-2.91.37-4.15 1.02l3.13 3.13zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9zm9-7.5c1.38 0 2.5 1.12 2.5 2.5 0 .99-.58 1.84-1.42 2.25l2.48 2.48c.11.02.23.03.35.03 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.01-.2C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-.57 0-1.09.2-1.51.52l3.16 3.16c.41-.85 1.26-1.43 2.25-1.43z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M2.81 2.81 1.39 4.22l4.64 4.64c-.27.4-.43.87-.43 1.39 0 1.38 1.12 2.5 2.5 2.5.52 0 .99-.16 1.4-.43l.02.02-.02.16c0 1.38 1.12 2.5 2.5 2.5.05 0 .1-.01.16-.02l1.64 1.64C12.67 18.12 12 19.98 12 22c2.02 0 3.88-.67 5.38-1.8l2.4 2.4 1.41-1.41L2.81 2.81z"
}, "1")], 'MacroOffSharp');

exports.default = _default;